const types = Object.freeze({
  SET_TO_DO_SNAPSHOT: 'SET_TO_DO_SNAPSHOT',
  SET_ROUTINES_SNAPSHOT: 'SET_ROUTINES_SNAPSHOT',
  SET_ACTIVITY_BOARD_SNAPSHOT: 'SET_ACTIVITY_BOARD_SNAPSHOT',
})

export default types
